/*
 * Module for the Contribution Rates index page.
 */
rs.module("system/configuration/contributionrates/index",

    [
        "controls/data/grid"
    ],

    function (gridModule) {

        // Initialize the page
        function initialize(jsSelectors, backendUrl, lrsGridApi) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var gridRadioButtons = criteria.js(jsSelectors.gridRadioButtons);
            var loadingSpinner = criteria.js(jsSelectors.loadingSpinner);

            // Handle radio button change
            gridRadioButtons.find('input').click(function () {

                loadingSpinner.show();

                gridModule.update(
                    backendUrl,

                    { filterAction: gridRadioButtons.find('input:checked').val() },

                    lrsGridApi.agGridApi,

                    function done(gridUpdate) {
                        loadingSpinner.hide();
                    }
                );
            });
        }

        var exports = {
            initialize: initialize,
        };

        return exports;
    }
);